import React from "react";
import { openConsult } from "../lib/api";
import Seo from "../components/Seo";

export default function ComingSoon({ eyebrow, title, accent, line, path, testid }) {
  return (
    <div className="w-full bg-[#F8F2E8] text-[#1F1B18]" data-testid={testid}>
      <Seo title={title} description={line} path={path} />
      <section className="min-h-[calc(100vh-73px)] flex flex-col items-center justify-center text-center px-6 py-24">
        <p className="font-typewriter text-sm sm:text-base tracking-[0.4em] uppercase text-[#8B6B4A]">{eyebrow}</p>
        <h1
          className="font-cormorant leading-[0.95] tracking-tight mt-8"
          style={{ fontSize: "clamp(3rem, 7vw, 7rem)" }}
          data-testid={`${testid}-headline`}
        >
          {title} <span className="italic text-[#D9739A]">{accent}</span>
        </h1>
        <p className="font-cormorant italic text-2xl sm:text-3xl text-[#1F1B18]/70 mt-10 max-w-2xl">{line}</p>
        <button
          type="button"
          onClick={() => openConsult("Partner with Us")}
          data-testid={`${testid}-partner-cta`}
          className="mt-14 inline-flex items-center gap-4 bg-[#1F1B18] text-[#F8F2E8] px-10 py-5 rounded-full font-typewriter text-base tracking-[0.25em] uppercase hover:bg-[#D9739A] transition-colors duration-300"
        >
          Partner with Us <span className="text-[#D9739A]">⟶</span>
        </button>
      </section>
    </div>
  );
}
